import { readonly, ref } from 'vue';
import type { ThemeName, ThemePreset } from './types';
import { applyTheme } from './apply-theme';
import { darkTheme } from './presets/dark';
import { lightTheme } from './presets/light';

const THEME_STORAGE_KEY = 'saas-platform-theme';

const presets: Record<ThemeName, ThemePreset> = {
  light: lightTheme,
  dark: darkTheme,
};

const currentThemeName = ref<ThemeName>('light');

function isThemeName(value: string | null): value is ThemeName {
  return value === 'light' || value === 'dark';
}

export function initTheme() {
  if (typeof document === 'undefined') {
    return;
  }
  const saved = localStorage.getItem(THEME_STORAGE_KEY);
  const name = isThemeName(saved) ? saved : 'light';
  setTheme(name);
}

export function setTheme(name: ThemeName) {
  const preset = presets[name];
  applyTheme(preset);
  currentThemeName.value = name;
  localStorage.setItem(THEME_STORAGE_KEY, name);
}

export function getThemePreset(name: ThemeName): ThemePreset {
  return presets[name];
}

export function useTheme() {
  return {
    currentTheme: readonly(currentThemeName),
    setTheme,
    presets,
  };
}
